import React from 'react';

import PropTypes from 'prop-types';
import { Redirect, Route, useHistory } from 'react-router-dom';

import auth from '../../services/Auth';

const CanRoute = ({ rule, subject, render, ...attr }) => {
  const history = useHistory();

  return (
    <Route
      {...attr}
      render={props =>
        auth.can(rule, subject) ? (
          render(props)
        ) : (
          <Redirect
            to={{
              pathname: '/dashboard',
              state: { from: history.from },
            }}
          />
        )
      }
    />
  );
};

CanRoute.propTypes = {
  rule: PropTypes.string.isRequired,
  subject: PropTypes.string.isRequired,
  render: PropTypes.func.isRequired,
};

export default CanRoute;
